/* Create action types */
import createActionTypes from '../createActionTypes';

export const SHOW_TOAST = createActionTypes('SHOW_TOAST');
